import { SxProps, Theme } from '@mui/material/styles';

export const spinnerContainerSx = {
  position: 'relative',
  width: '100%',
  height: '100%',
} satisfies SxProps<Theme>;
